import { render, staticRenderFns } from "./SendInvite.vue?vue&type=template&id=7246e978&"
import script from "./SendInvite.vue?vue&type=script&lang=js&"
export * from "./SendInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports